<template>
  <div>
    <UseAdvancedSettingForm
      v-model="useAdvanceSetting"
      :disabled="mode === modes.READONLY"
    />
    <div v-if="readonly">
      <AdvancedConfirm
        v-if="advanced.useAdvancedSetting"
        :form="advanced"
        @back="$emit('back', 'Advanced')"
      />
    </div>
    <div v-else>
      <v-card v-if="advanced.useAdvancedSetting" class="pt-4">
        <v-container>
          <DevicesForm
            :advanced="advanced"
            v-model="advanced.deliveryDevices"
          />
          <InventoriesForm
            :advanced="advanced"
            :menu-type="form.basicSetting.ownerProfileMenu.menuType"
            v-model="advanced.deliveryInventories"
          />
          <OnlyJapaneseDeviceForm v-model="advanced.onlyJapaneseDevice" />
          <DemographicForm
            v-model="advanced.demographicSetting"
            class="pt-1"
            hide-prefecture
          />
          <WeeklyDeliveryScheduleForm
            v-model="advanced.deliveryTimeSchedules"
            use-only-one-day
          />
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import UseAdvancedSettingForm from '@/components/Shared/Common/FormAdvancedUse'
import DevicesForm from '@/components/Shared/Common/FormAdvancedDevices'
import InventoriesForm from '@/components/Shared/Common/FormAdvancedInventories'
import OnlyJapaneseDeviceForm from '@/components/Shared/Common/FormOnlyJapaneseDevice.vue'
import DemographicForm from '@/components/Shared/Common/FormAdvancedDemographic'
import WeeklyDeliveryScheduleForm from '@/components/Shared/Common/FormAdvancedWeekly'
import AdvancedConfirm from './SimulationContentAdvancedConfirm'
import { mapGetters } from 'vuex'
import { modes } from '@/vuex/modules/simulation/constants'

export default {
  components: {
    UseAdvancedSettingForm,
    DevicesForm,
    InventoriesForm,
    OnlyJapaneseDeviceForm,
    DemographicForm,
    WeeklyDeliveryScheduleForm,
    AdvancedConfirm,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('simulation', ['mode']),
    modes() {
      return modes
    },
    readonly() {
      return this.mode === modes.READONLY
    },
    advanced() {
      return this.form.advancedSetting
    },
    errorMessage() {
      if (this.emptyDeliveryDevicesViolation) {
        return '配信デバイスが選択されていません。\n１つ以上選択してください。'
      } else if (this.emptyDeliveryInventoriesViolation) {
        return '配信面が選択されていません。\n１つ以上選択してください。'
      } else {
        return ''
      }
    },
    emptyDeliveryDevicesViolation() {
      return (
        this.advanced.useAdvancedSetting &&
        this.advanced.deliveryDevices.length === 0
      )
    },
    emptyDeliveryInventoriesViolation() {
      return (
        this.advanced.useAdvancedSetting &&
        this.advanced.deliveryInventories.length === 0
      )
    },
    useAdvanceSetting: {
      get() {
        return this.advanced.useAdvancedSetting
      },
      set(value) {
        this.advanced.changeUseAdvancedSetting(value)
      },
    },
  },
}
</script>
